// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"788":"bfe36997","840":"8467c59f"}[chunkId] + ".chunk.js";
};